import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NextIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { useSelector } from 'react-redux';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import ProductIcon from '../../components/common/ProductIcon';
import { SPLASH_PAGE_CARD } from '../../constants/tracking/TrackingSources';
import { isUngatedForMarketingPlusSelector } from '../../selectors/GatingSelectors';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SplashPageCard = ({
  titleKey,
  descriptionKey,
  pathname,
  productLine,
  showIcon = true,
  trackingSource = SPLASH_PAGE_CARD
}) => {
  const isUngatedForMarketingPlus = useSelector(isUngatedForMarketingPlusSelector);
  const handleExploreClick = () => {
    trackClickedLink({
      name: 'explore-link',
      value: getI18nText('splash-page.explore', {
        locale: 'en-us'
      }),
      type: 'internal',
      url: pathname,
      trackingSource
    });
  };
  return /*#__PURE__*/_jsxs(CardWrapper, {
    children: [/*#__PURE__*/_jsx(CardSection, {
      paddingBlockEnd: "300",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexWrap: isUngatedForMarketingPlus ? 'wrap' : 'nowrap',
        children: [showIcon && productLine && /*#__PURE__*/_jsx(ProductIcon, {
          iconStyle: {
            marginInlineEnd: '300'
          },
          name: productLine
        }), /*#__PURE__*/_jsx(View, {
          maxInlineSize: "21ch",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h3",
            typography: "body-400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: titleKey
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      scrollable: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: descriptionKey
      })
    }), /*#__PURE__*/_jsx(CardSection, {
      children: /*#__PURE__*/_jsx(RouterLink, {
        to: createToObject(pathname),
        onClick: handleExploreClick,
        "aria-label": I18n.text('splash-page.exploreProduct', {
          product: I18n.text(titleKey)
        }),
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "splash-page.explore"
          }), /*#__PURE__*/_jsx(NextIcon, {
            size: "300"
          })]
        })
      })
    })]
  });
};
export default SplashPageCard;